<template>
    <div class="bg-dark text-white offer" v-if="offer">
        <v-flex align="center" class="p-4 h-100">
            <v-flex class="w-100">
                <div class="initials mr-4 flex-shrink-0" v-if="type == 'coach'">
                    {{ offer.initials }}
                </div>
                <div class="flex-grow-1" v-if="type == 'general'">
                    <h4 class="mb-0">
                        <b>{{ offer.full_name }}</b>
                    </h4>

                    <p class="m-0 text-muted">{{ offer.description }}</p>
                </div>
                <div class="flex-grow-1" v-else-if="offer.is_public">
                    <h4 class="mb-0" v-if="offer.is_public">
                        <b>{{ offer.full_name }}</b>
                    </h4>

                    <p class="m-0 text-muted">Coaching package on Ladder</p>
                </div>
                <div class="flex-grow-1" v-else>
                    <h4 class="mb-0">Ladder Coaching</h4>
                    <p class="mb-0 text-muted">
                        An invitation to work with {{ name }} on Ladder
                    </p>
                    <div class="trial mt-3" v-if="~~offer.trial_days">
                        {{ offer.trial_days }} days free
                    </div>
                </div>
                <div
                    class="text-right flex-shrink-0 flex-grow-0"
                    v-if="
                        !offer.base_price ||
                        (
                            !offer.percent_off &&
                            !offer.trial_days
                        )
                    "
                >
                    <h4 class="mb-0">${{ offer.price }}</h4>
                    <div class="text-muted">per month</div>
                    <div class="trial mt-3" v-if="~~offer.trial_days">
                        {{ offer.trial_days }} days free
                    </div>
                </div>
                <v-flex class="text-right flex-shrink-0 flex-grow-0" v-else>
                    <div>
                        <div class="pr-4" v-if="~~offer.percent_off">Normal Price</div>
                        <div class="pr-4">Offer</div>
                        <h6 class="mt-2 pt-2 pr-4 border-top">
                            Monthly Price<span v-if="~~offer.trial_days"> (after {{ ~~offer.trial_days }} days)</span>
                        </h6>
                    </div>
                    <div>
                        <div v-if="~~offer.percent_off">
                            <strike class="text-muted"
                                >${{ parseFloat(offer.base_price) }}</strike
                            >
                        </div>
                        <div class="text-success">
                            <template v-if="~~offer.trial_days"
                                >{{ ~~offer.trial_days }} days free</template
                            >
                            <template
                                v-if="~~offer.trial_days && ~~offer.percent_off"
                                >&nbsp;+&nbsp;</template
                            >
                            <template v-if="~~offer.percent_off"
                                >{{ offer.percent_off }}% off</template
                            >
                        </div>
                        <h5 class="mt-2 pt-2 border-top">${{ offer.price }}</h5>
                    </div>
                </v-flex>
            </v-flex>
        </v-flex>
        <div class="text-right pr-4 pb-4" v-if="~~offer.price"><small><em>* <span v-if="~~offer.trial_days">After your free {{ ~~offer.trial_days }} days, your</span><span v-else>Your</span> credit card will be charged ${{ offer.price }} monthly. You may cancel your membership at any time.</em></small></div>
    </div>
</template>

<script>
import store from "@/store.js";

export default {
    name: "CheckoutOffer",
    data() {
        return {
            shared: store.state
        };
    },
    computed: {
        offer() {
            if (!this.shared.offer) {
                return null;
            }

            return this.shared.offer;
        },
        initials() {
            let initials = "";

            let split = this.name.split(" ");
            initials = `${split[0][0]}${split[1][0]}`;

            return initials;
        },
        name() {
            return this.type == "coach"
                ? this.shared.offer.coach.account.full_name
                : this.shared.offer.organization.general.name;
        },
        type() {
            return this.shared.offer.coach ? "coach" : "general";
        }
    }
};
</script>

<style scoped lang="scss">
.offer {
    border-radius: 4px;
}
.logo {
    font-size: 1.5rem;
    margin-left: 1rem;
}
.trial {
    border-radius: 4px;
    background-color: $success;
    color: $dark;
    font-weight: bold;
    display: inline-block;
    padding: 2px 8px;
    font-size: small;
    text-transform: uppercase;
}
.initials {
    text-transform: uppercase;
    font-weight: bold;
    background-color: $white;
    color: $dark;
    width: 4rem;
    height: 4rem;
    font-size: 2rem;
    line-height: 4rem;
    border-radius: 50%;
    text-align: center;
}
</style>
